module.exports = __webpack_public_path__ + "img/bus_red.1784b446.svg";